export function BookingSkeleton() {
  return (
    <div className='min-h-screen bg-background py-8'>
      <div className='container-responsive max-w-3xl'>
        {/* Progress Steps Skeleton */}
        <div className='mb-8'>
          <div className='flex justify-between items-center'>
            {[1, 2, 3].map((i) => (
              <div key={i} className='flex items-center flex-1'>
                <div className='w-10 h-10 rounded-full bg-muted animate-pulse' />
                {i < 3 && (
                  <div className='flex-1 h-1 bg-muted animate-pulse mx-2' />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Form Card Skeleton */}
        <div className='bg-white rounded-lg border p-6 space-y-6'>
          <div className='h-7 bg-muted rounded w-48 animate-pulse mb-4' />

          {[1, 2, 3, 4].map((i) => (
            <div key={i}>
              <div className='h-4 bg-muted rounded w-32 animate-pulse mb-2' />
              <div className='h-10 bg-muted rounded w-full animate-pulse' />
            </div>
          ))}

          {/* Action Buttons */}
          <div className='flex gap-3 pt-4'>
            <div className='h-10 bg-muted rounded flex-1 animate-pulse' />
            <div className='h-10 bg-primary/20 rounded flex-1 animate-pulse' />
          </div>
        </div>
      </div>
    </div>
  )
}
